import { cyan, green, red, yellow } from "colorette";

export const highlighter = {
  error: red,
  warn: yellow,
  info: cyan,
  success: green,
};
